import axios from "../../services/Api";
import {
	FETCH_ALL_JOBS,GET_USERS_TO_ASSIGN_JOB,
	FETCH_ERROR,
	FETCH_CELL_RACK_LOCATION,
	FETCH_JOB_DETAIL,
	FETCH_START,
	FETCH_SUCCESS,
	FETCH_WAREHOUSE_FLOORS,
	FETCH_TEMPLATE_HEADERS,
	FETCH_JOB_TYPES,
	FETCH_JOB_TYPES_COUNT,
	FETCH_SHIPMENTS,
	FETCH_JOB_STATUS_COUNT,
	FETCH_JOB_TYPE_DETAILS,
	FETCH_ALL_JOB_ACTION,
	FETCH_ALL_JOBTYPE_ACTION_ID,
	SHOW_MESSAGE,
	FETCH_JOB_LOCATION_DETAIL,
	FETCH_JOB_PENDENCY_DETAIL,
	FETCH_JOB_PROCESS_CONFIG,
	GENERATE_JOB_DETAIL,
	FETCH_JOB_CREATION,
	FETCH_WORK_ORDER_LIST_CONFIG,
	FETCH_JOB_SHIPMENT_DETAIL,
	FETCH_SUGGESTION_LOCATION,
	FETCH_JOB_LOCATION_GROUPVIEW_DATA,
	FETCH_ALL_JOB_SCANNING_LOGS_DATA,
	FETCH_JOB_USER_PERFOMANCE_SUMMARY,
	FETCH_JOB_TYPE_WISE_COUNT_DATA,
	FETCH_JOB_LABEL_TEMPLATE_HEADERS,
	FETCH_JOB_LABEL_TEMPLATES_DATA,
	FETCH_OUTWARD_LABEL_SALES_DATA,
	FETCH_OUTWARD_LABEL_SKU_DATA,
	FETCH_OUTWARD_LABEL_INVENTORY_DATA,
	FETCH_JOB_LOCATION_SUGGESTIONS
} from "../types";
import { showToast } from "../../services/functions";

//All Job action ID 
export const getAllJobActions =(body, callBackFunction) => {
	return async (dispatch) => {
		dispatch({ type: FETCH_START });
		await axios.post("jobTypeAction/getAllJobActions", body)
		.then(({ data: { success, data, message } }) => {
			if (success) {
				dispatch({ type: FETCH_SUCCESS });
				dispatch({type: FETCH_ALL_JOB_ACTION,payload: {data}})
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: message });
				dispatch({type: FETCH_ALL_JOB_ACTION,payload:{data:[]} });
			}
			if(callBackFunction){
				callBackFunction({ success, data, message });
			}
		})
		.catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			// //("Error:", error.message);
		});
		
	};
};
//Job Type Listing and creation
export const getCompanyWiseJobActionID =(body, callBackFunction) => {
	return async (dispatch) => {
		dispatch({ type: FETCH_START });
		await axios.post("jobTypeAction/getCompanyWiseJobActionID", body)
		.then(({ data: { success, data, message } }) => {
			if (success) {
				dispatch({ type: FETCH_SUCCESS });
				dispatch({type: FETCH_ALL_JOBTYPE_ACTION_ID,payload: {data}})
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: message });
				dispatch({type: FETCH_ALL_JOBTYPE_ACTION_ID,payload:{data:[]} });
			}
			if(callBackFunction){
				callBackFunction({ success, data, message });
			}
		})
		.catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			// //("Error:", error.message);
		});
		
	};
};
export const getAllJobTypes = (body = {},callBackFunction) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios
			.post("jobType/getJobTypesList", body)
			.then(({ data: { success, count, data, message } }) => {
				if (success) {
					dispatch({ type: FETCH_SUCCESS });
					dispatch({type: FETCH_JOB_TYPES,payload: { data, count }});
				} 
				else {
					dispatch({type: FETCH_ERROR,payload: message,});
					dispatch({type: FETCH_JOB_TYPES,payload: { }});
				}
				if(callBackFunction)callBackFunction({ success, count, data, message })
			})
			.catch(function (error) {
				dispatch({ type: FETCH_ERROR, payload: error.message });
				if(callBackFunction)callBackFunction({ success:false, count:0, data:[], message:error.message })
				//("Error****:", error.message);
			});
	};
};
export const getJobTypeStatusCount = (body = {},callBackFunction) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios
			.post("jobType/getJobTypeStatusCount", body)
			.then(({ data: { success, data, message } }) => {
				if (success) {
					dispatch({ type: FETCH_SUCCESS });
					dispatch({type: FETCH_JOB_TYPES_COUNT,payload: { data,success,message }});
				} 
				else {
					dispatch({type: FETCH_ERROR,payload: message,});
					dispatch({type: FETCH_JOB_TYPES_COUNT,payload: { }});
				}
				callBackFunction({ success, data, message })
			})
			.catch(function (error) {
				dispatch({ type: FETCH_ERROR, payload: error.message });
				//("Error****:", error.message);
			});
	};
};

export const addJobTypes = (body = {},callBackFunction) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios
			.post("jobType/addJobType", body)
			.then(({ data: { success, message } }) => {
				if (success) {
					dispatch({ type: FETCH_SUCCESS });
					dispatch({ type: SHOW_MESSAGE,payload: message});
				} 
				else {
					dispatch({type: FETCH_ERROR,payload: message});
				}
				callBackFunction({ success, message })
			})
			.catch(function (error) {
				dispatch({ type: FETCH_ERROR, payload: error.message });
				//("Error****:", error.message);
			});
	};
};
export const updateJobTypes = (body = {},callBackFunction) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios
			.post("jobType/updateJobType", body)
			.then(({ data: { success, message } }) => {
				if (success) {
					dispatch({ type: FETCH_SUCCESS });
					dispatch({ type: SHOW_MESSAGE,payload: message});
				} 
				else {
					dispatch({type: FETCH_ERROR,payload: message});
				}
				callBackFunction({ success, message })
			})
			.catch(function (error) {
				dispatch({ type: FETCH_ERROR, payload: error.message });
				//("Error****:", error.message);
			});
	};
};
export const deleteJobTypes = (body = {},callBackFunction) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios
			.post("jobType/deleteJobType", body)
			.then(({ data: { success, message } }) => {
				if (success) {
					dispatch({ type: FETCH_SUCCESS });
					dispatch({ type: SHOW_MESSAGE,payload: message});
				} 
				else {
					dispatch({type: FETCH_ERROR,payload: message});
				}
				callBackFunction({ success, message })
			})
			.catch(function (error) {
				dispatch({ type: FETCH_ERROR, payload: error.message });
				//("Error****:", error.message);
			});
	};
};



//Job Listing and creation
export const getAllJobs =(body, callBackFunction) => {
	return async (dispatch) => {
		dispatch({ type: FETCH_START });
		await axios.post("job/getJobList", body)
		.then(({ data: { success, count=0, data, message } }) => {
			if (success) {
				dispatch({ type: FETCH_SUCCESS });
				dispatch({type: FETCH_ALL_JOBS,payload: { data, count }})
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: message });
				dispatch({type: FETCH_ALL_JOBS,payload: { data:[], count:0 }})
			}

			if(callBackFunction)callBackFunction({ success, count, data, message });
		})
		.catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			// //("Error:", error.message);
		});
		
	};
};

export const getJobsStatus = (body = { type: "wms" }, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios
			.post("job/getJobStatusCount", body)
			.then(({ data: { success, count, data, message } }) => {
				if (success) {
					dispatch({ type: FETCH_SUCCESS });
					dispatch({type: FETCH_JOB_STATUS_COUNT,payload: { data, count }});
					if (cb) {
						cb({ success: true, data, count, message });
					}
				}
				else {
					dispatch({type: FETCH_ERROR,payload: message});
					dispatch({type: FETCH_JOB_STATUS_COUNT,payload: { }});
					if (cb) {
						cb({ success: false, data: {}, count: 0, message });
					}
				}
			})
			.catch(function (error) {
				dispatch({ type: FETCH_ERROR, payload: error.message });
				if (cb) {
					cb({ success: false, data: {}, count: 0, message: error?.message || "Failed to fetch job status" });
				}
				//("Error****:", error.message);
			});
	};
};


export const getJobTypeDetails = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('jobType/getJobTypesDetail', {
            ...payload
        }
        ).then(({ data }) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_JOB_TYPE_DETAILS, payload: data?.data || {} })
            }
            else {
                dispatch({ type: FETCH_ERROR, payload: data.message });
                dispatch({ type: FETCH_JOB_TYPE_DETAILS, payload: {} })
            }

            if (cb) {
                cb(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_ERROR, payload: error.message });
            if (cb) {
                cb({ success: false, message: error.message })
            }
        });
    }
};


// export const getJobDetail = (body) => {
// 	return (dispatch) => {
// 		dispatch({ type: FETCH_START });
// 		axios
// 			.post("job/getJobDetail", body)
// 			.then(({ data: { success, count, data, message } }) => {
// 				if (success) {
// 					callback();
// 				} else {
// 					dispatch({
// 						type: FETCH_ERROR,
// 						payload: message,
// 					});
// 				}

// 				function callback() {
// 					dispatch({ type: FETCH_SUCCESS });
// 					dispatch({
// 						type: FETCH_JOB_DETAIL,
// 						payload: { data },
// 					});

// 					dispatch(
// 						getGridDetails({
// 							commonCellId: parseToCellIdsRackIds(data),
// 							type: ["block", "rack"],
// 						})
// 					);
// 				}
// 			})
// 			.catch(function (error) {
// 				dispatch({ type: FETCH_ERROR, payload: error.message });
// 				//("Error****:", error.message);
// 			});
// 	};
// };

export const getJobDetailV2 = (body,callBack) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios
			.post("job/getJobDetailV2", {...body,call_from:"web"})
			.then(({ data: { success, count, data, message } }) => {
				if (success) {
					dispatch({ type: FETCH_SUCCESS });
					dispatch({type: FETCH_JOB_DETAIL,payload: { data,count }});
				} 
				else {
					dispatch({type: FETCH_ERROR,payload: message});
					dispatch({type: FETCH_JOB_DETAIL,payload: { data:[],count:0 }});
				}
				
				if(callBack){
					callBack({success:success || false,message})
				}
			})
			.catch(function (error) {
				if(callBack){
					callBack({success:false,message:error.message})
				}
				dispatch({type: FETCH_JOB_DETAIL,payload: { data:[],count:0 }});
				dispatch({ type: FETCH_ERROR, payload: error.message });
				//("Error****:", error.message);
			});
	};
};
export const getJobLocationDetail = (body,callBack) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios
			.post("job/getJobLocationDetail", {...body,call_from:"web"})
			.then(({ data: { success, count=0, data=[], message } }) => {
				if (success) {
					dispatch({ type: FETCH_SUCCESS });
					dispatch({type: FETCH_JOB_LOCATION_DETAIL,payload: { data,count }});
				} 
				else {
					dispatch({type: FETCH_ERROR,payload: message});
					dispatch({type: FETCH_JOB_LOCATION_DETAIL,payload: { data,count}});
				}

				if(callBack){
					callBack({success:success || false,message,data,count})
				}
			})
			.catch(function (error) {
				if(callBack){
					callBack({success:false,message:error.message,data:[],count:0})
				}
				dispatch({ type: FETCH_ERROR, payload: error.message });
				//("Error****:", error.message);
			});
	};
};

export const generateJobPickList = (obj,callback) => {
	return async dispatch => {
	  dispatch({ type: FETCH_START });
	  await axios
		.post("/report/generatePickList", obj)
		.then(({ data }) => {
		  if (data.success) {
			dispatch({ type: FETCH_SUCCESS, payload: data.success });
			dispatch({ type: GENERATE_JOB_DETAIL, payload: data.downloadURL})
		  } 
		  else {
			dispatch({ type: FETCH_ERROR, payload: data.message });
			dispatch({ type: GENERATE_JOB_DETAIL, payload: "" });
		  }
		  if(callback){
			callback({success:data.success,message:data.message,data:data.data})
		  }
		})
		.catch(function (error) {
		  dispatch({ type: FETCH_ERROR, payload: error.message });
		  if(callback){
			callback({success:false,message:error.message,data:""})
		  }
		  ////("Error****:", error.message);
		});
	};
};

export const getJobPendencyDetail = (body,callBack) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios
			.post("job/getPendencyDetail", body)
			.then(({ data: { success, count=0, data=[], message } }) => {
				if (success) {
					dispatch({ type: FETCH_SUCCESS });
					dispatch({type: FETCH_JOB_PENDENCY_DETAIL,payload: { data,count }});
				} 
				else {
					dispatch({type: FETCH_ERROR,payload: message});
					dispatch({type: FETCH_JOB_PENDENCY_DETAIL,payload: { data,count}});
				}

				if(callBack){
					callBack({success:success || false,message,data,count})
				}
			})
			.catch(function (error) {
				if(callBack){
					callBack({success:false,message:error.message,data:[],count:0})
				}
				dispatch({ type: FETCH_ERROR, payload: error.message });
				//("Error****:", error.message);
			});
	};
};
export const getJobProcessConfig = (body,callBack) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		dispatch({type: FETCH_JOB_PROCESS_CONFIG,payload:{}});
		axios
			.post("base/getJobProcessConfig", body)
			.then(({ data: { success, data={}, message } }) => {
				if (success) {
					dispatch({ type: FETCH_SUCCESS });
					dispatch({type: FETCH_JOB_PROCESS_CONFIG,payload:data});
				} 
				else {
					dispatch({type: FETCH_ERROR,payload: message});
					dispatch({type: FETCH_JOB_PROCESS_CONFIG,payload:{}});
				}

				if(callBack){
					callBack({success:success || false,message,data})
				}
			})
			.catch(function (error) {
				if(callBack){
					callBack({success:false,message:error.message,data:{}})
				}
				dispatch({ type: FETCH_ERROR, payload: error.message });
				//("Error****:", error.message);
			});
	};
};


export const getUsersToAssignJob = (obj,callback) => {
	return async dispatch => {
	  dispatch({ type: FETCH_START });
	  await axios
		.post("/job/getUsersToAssignJob", obj)
		.then(({ data }) => {
		  if (data.success) {
			dispatch({ type: FETCH_SUCCESS, payload: data.success });
			dispatch({ type: GET_USERS_TO_ASSIGN_JOB, payload: data?.data || []})
		  } 
		  else {
			dispatch({ type: FETCH_ERROR, payload: data.message });
			dispatch({ type: GET_USERS_TO_ASSIGN_JOB, payload: [] });
		  }
		  if(callback){
			callback(data)
		  }
		})
		.catch(function (error) {
		  dispatch({ type: FETCH_ERROR, payload: error.message });
		  if(callback){
			callback({success:false,message:error.message,data:[]})
		  }
		});
	};
};

export const assignJobToUser = (obj,callback) => {
	return async dispatch => {
	  dispatch({ type: FETCH_START });
	  await axios
		.post("/job/assignJobToUser", obj)
		.then(({ data }) => {
		  if (data.success) {
			dispatch({ type: FETCH_SUCCESS, payload: data.success });
		  } 
		  else {
			dispatch({ type: FETCH_ERROR, payload: data.message });
		  }
		  if(callback){
			callback({success:data.success,message:data.message})
		  }
		})
		.catch(function (error) {
		  dispatch({ type: FETCH_ERROR, payload: error.message });
		  if(callback){
			callback({success:false,message:error.message,})
		  }
		});
	};
};
export const approveJobCompletion = (obj,callback) => {
	return async dispatch => {
	  dispatch({ type: FETCH_START });
	  await axios
		.post("/job/approveJobCompletion", obj)
		.then(({ data }) => {
		  if (data.success) {
			dispatch({ type: FETCH_SUCCESS, payload: data.success });
		  } 
		  else {
			dispatch({ type: FETCH_ERROR, payload: data.message });
		  }
		  if(callback){
			callback({success:data.success,message:data.message})
		  }
		})
		.catch(function (error) {
		  dispatch({ type: FETCH_ERROR, payload: error.message });
		  if(callback){
			callback({success:false,message:error.message,})
		  }
		});
	};
};

export const getTemplateHeaders = (body) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios
			.post("inventory/getTemplateHeader", body)
			.then(({ data: { success, count, templateHeader, message } }) => {
				if (success) {
					callback();
				} else {
					dispatch({
						type: FETCH_ERROR,
						payload: message,
					});
				}

				function callback() {
					dispatch({ type: FETCH_SUCCESS });
					dispatch({
						type: FETCH_TEMPLATE_HEADERS,
						payload: { data: templateHeader },
					});
				}
			})
			.catch(function (error) {
				dispatch({ type: FETCH_ERROR, payload: error.message });
				//("Error****:", error.message);
			});
	};
};



export const getShipments = (body = {}) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios
			.post("inventory/getInventoryData", body)
			.then(({ data: { success, count, data, message } }) => {
				if (success) {
					callback();
				} else {
					dispatch({
						type: FETCH_ERROR,
						payload: message,
						payload: { data:[], count:0 }
					});
				}

				function callback() {
					dispatch({ type: FETCH_SUCCESS });
					dispatch({
						type: FETCH_SHIPMENTS,
						payload: { data, count },
					});
				}
			})
			.catch(function (error) {
				dispatch({ type: FETCH_ERROR, payload: error.message });
				//("Error****:", error.message);
			});
	};
};

export const scheduleJob = (body, callBackFunction) => {
	return async (dispatch) => {
		dispatch({ type: FETCH_START });
		await axios.post("job/scheduleWarehouseJob", body)
		.then(({ data: { success, message } }) => {
			if (success) {
				dispatch({ type: FETCH_SUCCESS });
			} else {
				dispatch({ type: FETCH_ERROR, payload: message });
			}
			if (callBackFunction) callBackFunction({ success, message });
		})
		.catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			if (callBackFunction) callBackFunction({ success: false, message: error.message });
		});
	};
};

export const createJob = (body,callBackFunction) => {
	return async (dispatch) => {
		dispatch({ type: FETCH_START });
		await axios.post("job/createWarehouseJob", body)
		.then(({ data: { success, message } }) => {
			if (success) {
				dispatch({ type: FETCH_SUCCESS });
			} 
			else {
				dispatch({type: FETCH_ERROR,payload: message,});
			}

			if(callBackFunction){
				callBackFunction({success,message}) 
			}
		})
		.catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			//("Error****:", error.message);
			
			if(callBackFunction){
				callBackFunction({ success: false, message: error.message })
			}
		});
	};
};
export const reverseStackingJobCreation = (body, callBackFunction) => {
	return async (dispatch) => {
		dispatch({ type: FETCH_START });
		await axios.post("job/reverseStackingJobCreation", body)
			.then(({ data: { success, message } }) => {
				if (success) {
					dispatch({ type: FETCH_SUCCESS });
				}
				else {
					dispatch({ type: FETCH_ERROR, payload: message, });
				}

				if (callBackFunction) {
					callBackFunction({ success, message })
				}
			})
			.catch(function (error) {
				dispatch({ type: FETCH_ERROR, payload: error.message });
				//("Error****:", error.message);

				if (callBackFunction) {
					callBackFunction({ success: false, message: error.message })
				}
			});
	};
};
export const createConnectedJob = (body, callBackFunction) => {
	return async (dispatch) => {
		dispatch({ type: FETCH_START });
		await axios.post("job/linkedJobCreationWithPicking", body)
			.then(({ data: { success, message } }) => {
				if (success) {
					dispatch({ type: FETCH_SUCCESS });
				}
				else {
					dispatch({ type: FETCH_ERROR, payload: message, });
				}

				if (callBackFunction) {
					callBackFunction({ success, message })
				}
			})
			.catch(function (error) {
				dispatch({ type: FETCH_ERROR, payload: error.message });
				//("Error****:", error.message);

				if (callBackFunction) {
					callBackFunction({ success: false, message: error.message })
				}
			});
	};
};

export const getInvForJobCreation = (payload, callBack) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('/job/getInvForJobCreation', {
               ...payload
        }).then(({data}) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_JOB_CREATION, payload: data.data})
             
            } 
            else {
                dispatch({type: FETCH_ERROR, payload: data.message});
                dispatch({ type: FETCH_JOB_CREATION, payload: []})
            }
            if(callBack){
                callBack(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_JOB_CREATION, payload: []})
            dispatch({type: FETCH_ERROR, payload: error.message});
            if(callBack){
                callBack({success:false,message:error.message})
            }
            //("Error****:", error.message);
        });
    }
};

function parseToCellIdsRackIds(data) {
	// //({ parse: data });
	const result = data?.location?.reduce((acc, curr) => {
		if (curr.cellId) acc.push(curr.cellId);
		if (curr.rackId) acc.push(curr.rackId);
		return acc;
	}, []);

	// //({result})
	return result;
}

function parseIdToName(data) {
	// //({ parse: data });
	const result = data?.reduce((acc, curr) => {
		acc[curr._id] = curr.name;
		return acc;
	}, {});

	// //({result})
	return result;
}
function parseCellIdToName(data) {
	// //({ parse: data });
	const result = data?.reduce((acc, curr) => {
		acc[curr.cellId] = curr.name;
		return acc;
	}, {});

	// //({result})
	return result;
}

export const getWorkOrderListConfig = (payload,callBack) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('/report/getWorkerOrderConfig', {
               ...payload
        }).then(({data}) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_WORK_ORDER_LIST_CONFIG, payload: data.data})
             
            } 
            else {
                dispatch({type: FETCH_ERROR, payload: data.message});
                dispatch({ type: FETCH_WORK_ORDER_LIST_CONFIG, payload: []})
            }
            if(callBack){
                callBack(data)
            }
        }).catch(function (error) {
            dispatch({ type: FETCH_WORK_ORDER_LIST_CONFIG, payload: []})
            dispatch({type: FETCH_ERROR, payload: error.message});
            if(callBack){
                callBack({success:false,message:error.message})
            }
            //("Error****:", error.message);
        });
    }
};

export const endJobFunction = (payload, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('job/endJobs', {
            ...payload
        }
        ).then(({data}) => {
            if (data.success) {
                dispatch({ type: FETCH_SUCCESS });
            } 
            else {
                dispatch({type: FETCH_ERROR, payload: data.message});
            }
			if(cb){
				cb(data)
			}
    
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            //("Error****:", error.message);
            if(cb){
                cb({success:false,message:error.message})
            }
        });
    }
};

export const getJobShipmentDetails = (payload, cb) =>
{
    return (dispatch) =>
    {
        dispatch({type: FETCH_START});
        axios.post('job/getJobShipmentDetail', {
            ...payload
        }
        ).then(({data}) => {
            if (data.success){
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: FETCH_JOB_SHIPMENT_DETAIL, payload: {data: data?.data || {}, count: data?.count}})
            } 
            else{
                dispatch({type: FETCH_ERROR, payload: data.message});
                dispatch({ type: FETCH_JOB_SHIPMENT_DETAIL, payload: {data: {}, count: 0}})
            }

            if(cb){
                cb(data)
            }
        }).catch(function (error) {
            dispatch({type: FETCH_ERROR, payload: error.message});
            if(cb){
                cb({success:false, message: error.message})
            }
        });
    }
};

export const getSuggestionLocation = (body, cb) => {
	return async (dispatch) => {
	  dispatch({ type: FETCH_START });
	  await axios.post("job/getSuggestedLocation", body)
		.then(({ data }) => {
		  if (data.success) {
			dispatch({ type: FETCH_START, payload: data.success });
			dispatch({ type: FETCH_SUGGESTION_LOCATION, payload: data });
		  }
		  else {
			dispatch({ type: FETCH_ERROR, payload: data.message });
			dispatch({ type: FETCH_SUGGESTION_LOCATION, payload: {} });
		  }
		  if (cb) {
			cb({ success: data.success, message: data.message, data: data.data });
		  }
		})
			.catch(function (error) {
				dispatch({ type: FETCH_SUGGESTION_LOCATION, payload: {} });
				dispatch({ type: FETCH_ERROR, payload: error.message });
				if (cb) {
					cb({ success: false, message: error.message, data: "" });
				}
			});
	};
};

export const getJobLocationGroupViewData = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('job/getJobLocationByGroupView', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
				dispatch({ type: FETCH_JOB_LOCATION_GROUPVIEW_DATA, payload: { data: data?.data || [], count: data?.count } })
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
				dispatch({ type: FETCH_JOB_LOCATION_GROUPVIEW_DATA, payload: { data: [], count: 0 } })
			}

			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};

export const getAllJobScanningLogsData = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('job/getAllJobScanningLogs', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
				dispatch({ type: FETCH_ALL_JOB_SCANNING_LOGS_DATA, payload: data.data })
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
				dispatch({ type: FETCH_ALL_JOB_SCANNING_LOGS_DATA, payload: [] })
			}
			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};

export const getJobUserPerfomanceHistoryData = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('/job/getUserPerformanceSummary', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
				dispatch({ type: FETCH_JOB_USER_PERFOMANCE_SUMMARY, payload: data?.data })
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
				dispatch({ type: FETCH_JOB_USER_PERFOMANCE_SUMMARY, payload: null })
			}
			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};

export const closeJobForcefully = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('job/closeJobs', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
			}

			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });

			showToast(error.message, true);
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};

export const getJobScanningCount = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('job/getJobScanningCount', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
				dispatch({ type: FETCH_JOB_TYPE_WISE_COUNT_DATA, payload: data?.data })
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
				dispatch({ type: FETCH_JOB_TYPE_WISE_COUNT_DATA, payload: null })
			}
			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};

export const AddMoreStockForInspectionJob = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('/job/addMoreStockForInspection', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
			}

			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });

			showToast(error.message, true);
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};
export const MoveToStackJobCreationJob = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('/job/moveToStackJobCreation', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
			}

			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });

			showToast(error.message, true);
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};
export const jobCompletionOnApproveOnly = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('job/jobCompletionOnApproveOnly', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
			}

			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });

			showToast(error.message, true);
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};
export const PreShipmentInspectionCreationJob = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('/job/preShipmentInpectionCreation', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
			}

			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });

			showToast(error.message, true);
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};

export const ValidateDispatchPlan = (payload, callback) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('job/verifyDispatchPlan', payload).then(({ data }) => {
            if (data.success) {
                process(data)
            }
            else {
                //(data.message);
                dispatch({ type: FETCH_ERROR, payload: data.message });
                showToast(data.message, true)
                callback(null);
            }
            function process(data) {
				dispatch({ type: FETCH_SUCCESS });
				showToast(data.message, false);
				callback(data);
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			//("Error****:", error.message);
			showToast(error.message, true);
			callback(null)
		});
	}
};

export const ValidateExcelJobCompletion = (payload, callback) => {
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        axios.post('job/excelJobCompletion', payload).then(({ data }) => {
            if (data.success) {
                process(data)
            }
            else {
                //(data.message);
                dispatch({ type: FETCH_ERROR, payload: data.message });
                showToast(data.message, true)
                callback(null);
            }
            function process(data) {
				dispatch({ type: FETCH_SUCCESS });
				showToast(data.message, false);
				callback(data);
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			//("Error****:", error.message);
			showToast(error.message, true);
			callback(null)
		});
	}
};

export const VerifyPreShipmentInspection = (payload, callback) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('job/verifyPreShipmentInpection', payload).then(({ data }) => {
			if (data.success) {
				process(data)
			}
			else {
				//(data.message);
				dispatch({ type: FETCH_ERROR, payload: data.message });
				showToast(data.message, true)
				callback(null);
			}
			function process(data) {
				dispatch({ type: FETCH_SUCCESS });
				showToast(data.message, false);
				callback(data);
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			//("Error****:", error.message);
			showToast(error.message, true);
			callback(null)
		});
	}
};

export const getJobLabelTemplateHeaders = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('job/getJobTemplateHeaders', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
				dispatch({ type: FETCH_JOB_LABEL_TEMPLATE_HEADERS, payload: data?.data })
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
				dispatch({ type: FETCH_JOB_LABEL_TEMPLATE_HEADERS, payload: null })
			}
			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};

export const getJobLabelTemplatesData = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('/job/getOutwardLabelData', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
				dispatch({ type: FETCH_JOB_LABEL_TEMPLATES_DATA, payload: data?.data })
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
				dispatch({ type: FETCH_JOB_LABEL_TEMPLATES_DATA, payload: [] })
			}
			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};

export const getOutwardLabelSalesData = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('/job/getOutwardLabelSalesData', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
				dispatch({ type: FETCH_OUTWARD_LABEL_SALES_DATA, payload: data?.data })
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
				dispatch({ type: FETCH_OUTWARD_LABEL_SALES_DATA, payload: [] })
			}
			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};

export const getOutwardLabelSKUData = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('/job/getOutwardLabelSKUData', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
				dispatch({ type: FETCH_OUTWARD_LABEL_SKU_DATA, payload: data?.data })
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
				dispatch({ type: FETCH_OUTWARD_LABEL_SKU_DATA, payload: [] })
			}
			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};

export const getOutwardLabelInventoryData = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('/job/getOutwardLabelInventoryData', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
				dispatch({ type: FETCH_OUTWARD_LABEL_INVENTORY_DATA, payload: data?.data })
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
				dispatch({ type: FETCH_OUTWARD_LABEL_INVENTORY_DATA, payload: [] })
			}
			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};

export const getJobLocationSuggestionData = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: FETCH_START });
		axios.post('job/getJobLocationSuggestion', {
			...payload
		}
		).then(({ data }) => {
			if (data.success) {
				dispatch({ type: FETCH_SUCCESS });
				dispatch({ type: FETCH_JOB_LOCATION_SUGGESTIONS, payload: data.data })
			}
			else {
				dispatch({ type: FETCH_ERROR, payload: data.message });
				dispatch({ type: FETCH_JOB_LOCATION_SUGGESTIONS, payload: [] })
			}
			if (cb) {
				cb(data)
			}
		}).catch(function (error) {
			dispatch({ type: FETCH_ERROR, payload: error.message });
			if (cb) {
				cb({ success: false, message: error.message })
			}
		});
	}
};
